import { Ticket } from 'api';
import { useTranslation } from 'i18n';
import { Box, Button, Typography } from 'ui';

export const Success = ({ ticket }: { ticket: Ticket }) => {
  const { t } = useTranslation('orders');

  return (
    <Box
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
        display: 'flex',
        padding: 3,
      }}
    >
      <Typography
        variant="h5"
        align="center"
        sx={{
          mb: 2,
        }}
      >
        {t('supportIssueForm.success.title')}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mb: 2,
        }}
      >
        {t('supportIssueForm.success.description')}
      </Typography>
      <Button variant="primary" component="a" href={ticket.external_link} target="_blank" rel="noopener noreferrer">
        {t('supportIssueForm.success.actions.viewSupportIssue')}
      </Button>
    </Box>
  );
};
